module.exports = __webpack_public_path__ + "static/media/sample_lmroute_config.e4d74b90.csv";